/**
 * Resources are endpoints where you can:
 * 1) Get items: `GET /example`
 * 2) Store an item: `POST /example`
 * 3) Get an item: `GET /example/:id`
 * 4) Update an item: `PATCH /example/:id`
 * 5) Delete an item: `DELETE /example/:id`
 */
export const resources = {
    juries: "/api/admin/juries",
    sections: "/api/admin/sections",
    organizations: "/api/admin/organizations",
    salons: "/api/admin/salons",
    photos: "/api/customer/photos",
    awards: "/api/admin/awards",
    clubs: "/api/club/customer/clubs"
} as const

export default {
    ...resources,
    login: "/api/auth/login",
    register: "/api/auth/register",
    forgot: "/api/auth/forgot",
    reset: "/api/auth/reset",
    settings: "/api/customer/settings",
    details: "/api/customer/settings/details",
    password: "/api/customer/settings/password",
    current: "/api/customer/salons/current",
    participating: "/api/customer/salons/participating",
    past: "/api/customer/salons/past",
    jurySalons: "/api/jury/salons"
} as const